import type { TypographyProps } from '@mui/material';
import MuITypography from '@mui/material/Typography';
import { forwardRef } from 'react';

const Typography = forwardRef<HTMLElement, TypographyProps>((props, ref) => {
  return <MuITypography ref={ref} {...props} />;
});
Typography.displayName = 'Typography';
export default Typography;
